<!-- HACK csclip/app/javascript/packs/components/surveys/RadioButton.vue と同じ処理なので、一緒にする。RadioButton.vueは使用されていない可能性もあるので、確認する -->
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <label class="mb-3 font-middle">
          <span>
            {{ title }}
          </span>
          <required-badge v-show="required" />
        </label>
      </div>
    </div>
    <label
      v-if="description"
      class="mt-description font-small text-dark-gray mb-3 description d-block"
      :class="{ 'd-none': description === '' }"
      v-html="description"
    >
    </label>
    <error-message
      :errors="errors"
    />
    <div
      v-for="value in options"
      :key="value['name']"
      class="mb-3 d-inline-block"
      :class="[isPCWidth ? 'mr-7' : 'col-6 px-0', lineBlock ? 'col-12' : '']"
    >
      <input
        :id="value['name']"
        type="radio"
        :name="postName"
        :value="value['name']"
        :checked="value['name'] === clicked"
        :disabled="disabled"
        class="radiobutton-input d-none"
        @change="change(value)"
      >
      <label
        :for="value['name']"
        class="radiobutton-label"
      >
        {{ value['option'] }}
      </label>
    </div>
  </div>
</template>

<script>
import ErrorMessage from "./surveys/ErrorMessage.vue";
import RequiredBadge from "./surveys/RequiredBadge.vue";

export default {
  components: {
    ErrorMessage,
    RequiredBadge
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    postName: {
      type: String,
      default: "single_selected"
    },
    required: {
      type: Boolean,
      default: false
    },
    clicked: {
      type: String,
      default: ""
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    lineBlock: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerWidth: window.innerWidth
    };
  },
  computed: {
    isPCWidth() {
      return this.innerWidth >= 768;
    }
  },
  mounted() {
    window.addEventListener("resize", () => (this.innerWidth = window.innerWidth));
  },
  created() {
    const value = this.options.find(v => v.name === this.clicked);

    if (value != null) {
      this.$emit("change", value);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize");
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    }
  }
};
</script>

<style scoped>
.radiobutton-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  padding-left: 30px;
}
.radiobutton-label::before {
  content: "";
  position: absolute;
  top: 1px;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #DBDEE1;
  border-radius: 50%;
  box-sizing: border-box;
  background-color: #F7F8FA;
}

.radiobutton-input:checked + .radiobutton-label::before {
  border: 1px solid #0080FC;
  background: #0080FC;
}

.radiobutton-input {
  position: relative;
  display: block;
  cursor: pointer;
  user-select: none;
}
</style>
